import AbstractRepository from "@/repositories/AbstractRepository";
import {GridProfile} from "@/modules/GridProfile";

export interface GridProfileResponse {
    data: GridProfile;
}

export default class GridProfileRepository extends AbstractRepository {
    protected static resource: string = "gridprofile";

    protected static defaultFields: string[] =
        [
            "grids",
            "uuid",
            "hierarchyOwner.uuid",
            "widgets.uuid",
            "widgets.area",
            "widgets.type",
            "widgets.parameters"
        ];
}
